import { TXLogger } from "@tx/framework";
import { makeAutoObservable, runInAction } from "mobx";

import { IPAD_COOKIES } from "@client/context/config";
import RootContext from "@client/context/RootContext";

export class AuthStore {
	checkedIfLoggedIn = false;
	isLoggingIn = false;
	loggedIn = false;
	vendorID?: number;
	unauthorizedError = false;
	constructor(private rootContext: RootContext) {
		makeAutoObservable(this);

		if (!process.env.IS_SERVER) {
			this.rootContext.apiService.onUnauthorized(this.sessionRejected);
			this.checkIfLoggedIn();
		}
	}

	/**
	 * the server no longer accepts our session (expired, or the cookie was
	 * tampered with), so drop the cookies and let <App/> fall back to the login page
	 */
	sessionRejected = () => {
		if (!this.loggedIn) {
			return;
		}

		this.rootContext.modalStore.showError(
			"Please login again.",
			"Session expired."
		);

		this.logout();
	};

	checkIfLoggedIn = async () => {
		if (this.rootContext.cookieService.get(IPAD_COOKIES.sessionid)) {
			await this.authenticate();
		}

		runInAction(() => {
			this.checkedIfLoggedIn = true;
		});
	};

	authenticate = async () => {
		try {
			runInAction(() => {
				this.loggedIn = true;
			});

			if (window.location.pathname !== "/stats-dashboard") {
				await this.rootContext.vendorStore.initialise();
			}
			return true;
		} catch (err) {
			console.error("AuthStore :: failed to authenticate", err);
		}
	};

	login = async (email: string, password: string) => {
		this.isLoggingIn = true;
		this.unauthorizedError = false;
		try {
			await this.rootContext.apiService.api("/vendor/login", {
				email,
				password,
			});

			await this.authenticate();

			runInAction(() => {
				this.isLoggingIn = false;
			});
		} catch (error) {
			TXLogger.error("login()", "login error:", {
				error: { stack: error },
			});

			runInAction(() => {
				this.isLoggingIn = false;
				if (error.response.status === 401) {
					this.unauthorizedError = true;
				}
			});

			return;
		}
	};

	loginWithToken = async (token: string) => {
		this.isLoggingIn = true;

		try {
			await this.rootContext.apiService.api("/vendor/login-with-token", {
				token,
			});

			await this.authenticate();

			runInAction(() => {
				this.isLoggingIn = false;
			});
		} catch (error) {
			TXLogger.error("loginWithToken()", "loginWithToken error:", {
				error: { stack: error },
			});

			runInAction(() => {
				this.isLoggingIn = false;
			});

			return;
		}
	};

	logout = async () => {
		if (window) {
			this.rootContext.cookieService.removeAllCookies();

			runInAction(() => {
				this.loggedIn = false;
			});
		}
	};
}
